import { Box, Typography } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import LoadingAnimation from "../../../../../../components/common/LoadingAnimation/LoadingAnimation.tsx";
import { useAppStore } from "../../../../../../hooks/useStores.tsx";
import { DEFAULT_SCENE_PROCESSING_TIME } from "../../../../../constants/contants.ts";
import useDesignEditorContext from "../../../../../hooks/useDesignEditorContext.ts";
import styles from "./CampaignInformation.module.scss";

const CampaignInformation = () => {
	const { scenes } = useDesignEditorContext();
	const { designEditorStore } = useAppStore();
	const { t } = useTranslation("translation", { keyPrefix: "editor" });

	return (
		<Box
			className={clsx({
				[styles.campaignGenerationForm]: true,
			})}
		>
			<Box className={styles.content}>
				{designEditorStore.isGenerateAdsLoading ? (
					<Box className={styles.loadingContainer}>
						<LoadingAnimation
							loading={designEditorStore.hideCampaignResultContent}
							progressBarTime={DEFAULT_SCENE_PROCESSING_TIME * scenes.length}
							showAnimation={false}
							loadingStringsPosition={"left"}
							showLoadingStrings={false}
						/>
						<Typography className={styles.content}>
							{t("popup.campaign.loading")}{" "}
							<span className={styles.colored}>
								{designEditorStore.numberOfProcessedAdvertisements} / {scenes.length ?? 1}
							</span>
						</Typography>
					</Box>
				) : null}
			</Box>
		</Box>
	);
};

const ObservedComponent = observer(CampaignInformation);
export default ObservedComponent;
